module.exports = __webpack_public_path__ + "img/lb4.ba85dfdf.jpg";